import { inject } from '@angular/core';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';
import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsUser } from '../models/mps-user.model';

/**
 * Resolve the post-login destination for a user.
 *
 * When called from an injection context (route `redirectTo`, guards) pass no
 * argument and the current user is read via `inject(MpsUserService)`. When
 * called outside an injection context (e.g. an RxJS callback), pass the user
 * explicitly to avoid `inject()` (NG0203).
 */
export function homeRedirect(providedUser?: MpsUser | null): string {
  const user = providedUser !== undefined ? providedUser : inject(MpsUserService).getUser();

  // Not-yet-onboarded users are always sent to the welcome page first.
  if (user != null && user.cgu_accepted_at == null) {
    return '/' + applicationRouteNames.welcome;
  }

  const roleCode = user?.role?.code;

  switch (roleCode) {
    case MpsRoleHelper.COURRIER_AGENT:
      return '/' + applicationRouteNames.agentDashboard;
    case MpsRoleHelper.ADMIN_IT:
    case MpsRoleHelper.ADMIN_METIER:
      return '/' + applicationRouteNames.courrier.index;
    case MpsRoleHelper.USER:
    default:
      return '/' + applicationRouteNames.monCourrier;
  }
}
